export default "assets/images/arrow-beige-dfbc565b.png";